export const DAY = 86400000;

export function sessionDays(value) {
  const n = typeof value === 'number' ? value : NaN;
  return Number.isInteger(n) && n >= 0 && n <= 10 ? n : 1;
}
export function sessionDeadline(startedAt, days) {
  const duration = sessionDays(days);
  return duration === 0 ? null : startedAt + duration * DAY;
}
export function isExpired(info, now = Date.now()) {
  return info.expiresAt !== null && (!Number.isFinite(info.expiresAt) || now >= info.expiresAt);
}
export function nextMonthAt(timestamp = Date.now()) {
  const date = new Date(timestamp), day = date.getDate();
  date.setDate(1); date.setMonth(date.getMonth() + 1);
  const last = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  date.setDate(Math.min(day, last));
  return date.getTime();
}
export function reminderDue(owner, vaultId, now = Date.now()) {
  const key = `lunadesk.safe.practice.v1.${owner}.${vaultId}`;
  try {
    const stored = Number(localStorage.getItem(key));
    if (!stored || !Number.isFinite(stored)) { localStorage.setItem(key, String(nextMonthAt(now))); return false; }
    if (stored > now) return false;
    // Showing or dismissing counts as this month's reminder, never as a
    // successful password check. Wrong answers do not block the open vault.
    localStorage.setItem(key, String(nextMonthAt(now)));
    return true;
  } catch { return false; }
}
